import initialState from '@/store/state.js';
import router from '@/router/index.js';
import User from '@/entities/User.js';

export default {
    resetState(state) {
        initialState.authUser = new User();
        Object.assign(state, initialState);
    },

    setAuthUser(state, authUser) {
        state.authUser = new User(authUser);
    },

    setAuthUserAccount(state, account) {
        state.authUser.account = account;
    },

    setPageTitle(state, pageTitle) {
        state.pageTitle = pageTitle;

        // Set document title
        let title = 'Activix';

        if (pageTitle && (state.authUser.locale || router.currentRoute.meta.auth)) {
            title = `${pageTitle} | ${title}`;
        }

        document.title = title;
    },

    setTemplatePlaceholders(state, templatePlaceholders) {
        state.templatePlaceholders = templatePlaceholders;
    },

    setPartners(state, partners) {
        state.partners = partners;
    },

    setSegmentsUsage(state, segmentsUsage) {
        state.segmentsUsage = segmentsUsage;
    },
};
